import React, { useState, useEffect } from "react";
import { Form, Table, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";

export const TableProducts = ({data}) => {

  const [form] = Form.useForm();

  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      name: "",
      age: "",
      address: "",
      ...record,
    });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey("");
  };
  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setEditingKey("");
      } else {
        newData.push(row);
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log( errInfo);
    }
  };
 
  const [sizeWindow, setSizeWindow] = useState(true)
  useEffect(() => {
    window.innerWidth > 1000 ? setSizeWindow(true) : setSizeWindow(false)
  }, [])

  const columns = [
    {
      title: "Nombre",
      dataIndex: "productName",
      width: 150,
    fixed: sizeWindow ? "left" : false,
    },
    {
      title: "SKU",
      dataIndex: "sku",
      width: 100,
    },
    {
      title: "Categoria",
      dataIndex: "category",
      width: 120,
    },

    {
      title: "Marca",
      dataIndex: "brand",
      width: 100,
    },
    {
      title: "Modelo",
      dataIndex: "model",
      width: 100,
    },
    {
      title: "Ud. medida",
      dataIndex: "measure",
      width: 110,
    },
    {
      title: "Talla",
      dataIndex: "size",
      width: 70,
    },
    {
      title: "Color",
      dataIndex: "color",
      width: 100,
    },
    {
      title: "Stock",
      dataIndex: "quantity",
      width: 100,
    },
    {
      title: "Proveedor",
      dataIndex: "provider",
      width: 100,
    },
    {
      title: "Precio compra",
      dataIndex: "buyPrice",
      width: 130,
    }, 
    {
      title: "Precio venta",
      dataIndex: "sellPrice",
      width: 130,
    },
    {
      title: "Caracteristicas",
      dataIndex: "characteristics",
      width: 130,
    },
    {
      title: "Imagen",
      dataIndex: "fileImage",
      width: 100,
      render: (_, tag) => {
        return tag.fileImage ? (
          <img
            src={tag.fileImage}
            alt="comprobante"
            style={{ width: "100%" }}
          />
        ) : (
          ""
        );
      },
    },
    {
      title: "Accion",
      dataIndex: "operation",
      fixed: sizeWindow ? "right" : false,
      width: 100,
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.key)}
              style={{
                marginRight: 8,
              }}
              className="text-link"
            >
              Guardar
            </Typography.Link>
            <br/>
            <Typography.Link
              onClick={() => cancel()}
              style={{
                marginRight: 8,
              }}
              className="text-link"
            >
              Cancelar
            </Typography.Link>
          </span>
        ) : (
          <Typography.Link
            disabled={editingKey !== ""}
            onClick={() => edit(record)}
            className="text-link"
          >
           <EditOutlined/>
          </Typography.Link>
        );
      },
    },
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
      <Form form={form} component={false}>
          <Table
            bordered
            dataSource={data}
            columns={mergedColumns}
            pagination={{
              onChange: cancel,
            }}
            scroll={{
              x: 1300,
              y: 500,
            }}
          />
      </Form>
  )
}
